import { Injectable } from '@angular/core';
import { io } from 'socket.io-client';
import configJSON from '../../config/config.json';
import { environment } from '../../environments/environment';
import { CommonService } from '../common/common.service';
import { ServiceManagerService } from '../service-manager.service';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  socket: any;
  userDetails: any = {};
  transferData: any;
  messageReceiveTimeout: any;

  // private beforeUnloadListener = () => {
  //   if (this.socket) {
  //     this.disconnect();
  //   }
  // };
  // private visibilityChangeListener = () => {
  //   if (document.hidden) {
  //     this.disconnect();
  //   }
  // };

  constructor(
    public commonService: CommonService,
    private serviceManager: ServiceManagerService
  ) {}
  /**
   * Setups socket connection
   */
  setupSocketConnection() {
    this.socket = io(environment.socketUrl, {
      path: configJSON.socket.url,
    });
    // this.socket = io('https://outliveapi.think201.xyz', {
    //   transports: ['websocket'],
    //   path: '/socket.io/',
    // });
    var currentProgress = localStorage.getItem('currentProgress');
    if (currentProgress == 'chat-request') {
      this.commonService.current.status = 'CONNECTING';
      this.setAcceptTimeout();
    }

    // Listen socket to get the socket error
    this.socket.on('socket-error', (error: any) => {
      console.log(error);
    });

    this.socket.on('re-join', () => {
      var userId = localStorage.getItem('userId');
      if (userId) {
        this.join(userId, 'SERVICE-USER');
        this.commonService.showChat.next('reconnect');
      }
    });
    // Listen socket to get available client
    this.socket.on('available-client', (data: any) => {
      this.commonService.availableClient = data['client'];
    });

    // Listen socket to get chat reject status
    this.socket.on('chat-rejected', (data: any) => {
      this.commonService.clearTimeout();
      localStorage.removeItem('currentProgress');
      this.commonService.appModalEvent.next('chat-reject');
    });

    // Listen socket to get the chat accept status
    this.socket.on('chat-accepted', (data: any) => {
      localStorage.removeItem('currentProgress');
      this.commonService.clearTimeout();
      this.commonService.setChatProcess('CHAT-BEGIN');
      this.commonService.appModalEvent.next('chat-accept');
    });

    // Listen socket to get acknowledge for chat request
    // TODO: Remove this after testing
    this.socket.on('chat-request-received', (data: any) => {
      this.commonService.clearTimeout();
      this.setAcceptTimeout();
    });

    // Listen socket to get the acknowledge for sent message
    this.socket.on('message-received', (data: any) => {
      this.commonService.clearTimeout();
    });

    // Listen  socket to receive the messages from peer
    this.socket.on('receive-message', (data: any) => {
      var audio = new Audio(this.commonService.resource.audio.message_tone);
      audio.play();
      this.commonService.peerStatus = 'ONLINE';
      this.commonService.messageReceived.next(data);
      this.socket.emit('message-received', {
        id: this.commonService.peerDetails.peerId,
      });
      this.commonService.unreadMessage++;
    });

    // Listen socket to get information about the end chat
    this.socket.on('chat-ended', (data: any) => {
      this.socket.emit('chat-end-received', data);
      this.commonService.chatEnded.next(data);
    });

    // Listen socket to get the chat transfer event
    this.socket.on('chat-transfer', (data: any) => {
      this.commonService.setChatProcess('TRANSFER-REQUEST');
      this.commonService.appModalEvent.next('transfer-request');
      this.socket.emit('chat-transfer-received', data);
      this.transferData = data;
    });

    // Listen socket to get the transfer complete event
    this.socket.on('chat-transferred', (data: any) => {
      this.commonService.setChatProcess('TRANSFERRED');
      this.commonService.setChatProcess('PEER-LEFT');
      this.commonService.appModalEvent.next('transferred');
    });

    // Listen socket to get the transfer cancel event
    this.socket.on('chat-transfer-cancel', (data: any) => {
      this.commonService.clearTimeout();
      this.commonService.setChatProcess('TRANSFER-FAILED');
      this.commonService.appModalEvent.next('transfer-cancel');
    });

    this.socket.on('user-online-status', (data: any) => {
      this.commonService.peerStatus = data?.online ? 'ONLINE' : 'OFFLINE';
    });

    // window.addEventListener('beforeunload', this.beforeUnloadListener);
    // document.addEventListener(
    //   'visibilitychange',
    //   this.visibilityChangeListener
    // );

    // Catch All Listeners for Socket
    // Note: Comment or uncomment as per requirement
    // this.socket.onAny((event: any, ...args: any) => {
    //   console.log('Received event: ON', event, args);
    // });

    // this.socket.onAnyOutgoing((event: any, ...args: any) => {
    //   console.log('Outgoing event: EMIT', event, args);
    // });
  }

  /**
   * Disconnects socket service
   */
  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      // this.removeEventListeners();
    }
  }

  // removeEventListeners() {
  //   window.removeEventListener('beforeunload', this.beforeUnloadListener);
  //   document.removeEventListener(
  //     'visibilitychange',
  //     this.visibilityChangeListener
  //   );
  // }

  /**
   * Joins socket service
   * @param id
   * @param userType
   */
  join(id: any, userType: any) {
    this.socket.emit('join', { id: id, type: userType });
  }

  /**
   * Gets available client to show in home page.
   * Resolves once the server has responded with the live client list (or after
   * a fallback timeout), so callers can avoid rendering the peer list against a
   * stale/empty `commonService.availableClient` while the round trip is still
   * in flight - see _docs/changes/2026-09-07-client-bug-report-fixes.md.
   * @param client
   */
  getAvailableClient(client: any): Promise<void> {
    return new Promise((resolve) => {
      var resolved = false;
      var finish = () => {
        if (resolved) return;
        resolved = true;
        resolve();
      };
      this.socket.once('available-client', finish);
      this.socket.emit('get-available-client', { client: client });
      setTimeout(finish, 3000);
    });
  }

  /**
   * Sends message
   * @param message
   */
  sendMessage(message: any) {
    this.socket.emit('send-message', {
      id: this.commonService.peerDetails.peerId,
      sessionId: this.commonService.peerDetails.sessionId,
      message: message,
    });
  }

  /**
   * Chats request
   * @param request
   */
  chatRequest() {
    this.socket.emit('chat-request', this.userDetails);
    setTimeout(() => {
      this.commonService.clearTimeout();
      localStorage.removeItem('currentProgress');
      this.commonService.appModalEvent.next('request-error');
    }, 5000);
  }

  chatRequestCancel() {
    this.commonService.clearTimeout();
    localStorage.removeItem('currentProgress');
    this.commonService.appModalEvent.next('close-modal');
    this.commonService.current.status = 'INITIAL';
    this.socket.emit('chat-request-cancel', this.userDetails);
  }

  /**
   * Transfers chat response
   * @param isAccepted
   */
  transferChatResponse(isAccepted: any) {
    var event;
    if (isAccepted) {
      event = 'chat-transfer-client-accept';
      this.commonService.setChatProcess('TRANSFER-INITIATED');
      this.commonService.setChatProcess('TRANSFERRING');
    } else {
      event = 'chat-transfer-client-reject';
      this.commonService.setChatProcess('TRANSFER-CANCELED');
    }
    this.socket.emit(event, this.transferData);
  }

  /**
   * Gets available mentor
   * @returns
   */
  getAvailableMentor() {
    return new Promise((resolve: any, reject: any) => {
      var body = {
        user_type: 'Mentor',
      };
      this.serviceManager
        .CallBackendServiceAPI('get_peer_list', body)
        .subscribe((data: any) => {
          resolve(data['users']);
        });
    });
  }

  /**
   * Ends chat
   * @param request
   */
  endChat(request: any) {
    this.socket.emit('chat-end', request);
  }

  setAcceptTimeout() {
    setTimeout(() => {
      localStorage.removeItem('currentProgress');
      this.commonService.clearTimeout();
      this.commonService.appModalEvent.next('request-error');
    }, 120000);
  }
}
